export default function isNum(val: string): boolean {
  return !Number.isNaN(Number(val)) && !Number.isNaN(Number.parseFloat(val));
}
